import logSignUpPageViewed from '@alltrails/analytics/events/logSignUpPageViewed';
import TermsOfService from 'components/TermsOfService';
import { useEffect } from 'react';
import CustomProvider from 'components/CustomProvider';
import { FormattedMessage } from 'react-intl';
import RegistrationForm from '../RegistrationForm';
import * as styles from './styles/styles.module.scss';

type SignUpFormProps = {
  handleLoginClick?: React.MouseEventHandler<HTMLAnchorElement>;
  handleRegistrationSuccess?(...args: unknown[]): unknown;
  redirectTo?: string;
  referralLink?: string;
};

function SignUpForm({ handleRegistrationSuccess, redirectTo, handleLoginClick, referralLink }: SignUpFormProps) {
  useEffect(() => {
    logSignUpPageViewed();
  }, []);

  return (
    <CustomProvider>
      <div className={styles.container}>
        <div>
          <div className={styles.headContainer}>
            <FormattedMessage defaultMessage="Create your free account" />
          </div>
        </div>
        <RegistrationForm
          handleLoginClick={handleLoginClick}
          handleRegistrationSuccess={handleRegistrationSuccess}
          redirectTo={redirectTo}
          referralLink={referralLink}
          userEmailSubscribed
        />
        <TermsOfService />
      </div>
    </CustomProvider>
  );
}

SignUpForm.defaultProps = {
  handleRegistrationSuccess: () => {},
  redirectTo: null,
  referralLink: null
};

export default SignUpForm;
